import { getError } from "@/utils/helpers";
import StatuteResultService from "@/services/statute/StatuteResultService";

export const namespaced = true;

export const state = {
  i_results: [],
  i_loading: false,
  error: null,
};

export const mutations = {
  SET_RESULT(state, i_results) {
    state.i_results = i_results;
  },
  SET_LOADING(state, loading) {
    state.i_loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getResult({ commit }, famId) {
    commit("SET_LOADING", true);

    StatuteResultService.getResultI(famId)
      .then((response) => {
        commit("SET_RESULT", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  setDefault({ commit }) {
    commit("SET_LOADING", false);
    commit("SET_ERROR", null);
    commit("SET_RESULT", []);
  },
};
export const getters = {
  i_results: (state) => {
    return state.i_results;
  },
  i_loading: (state) => {
    return state.i_loading;
  },
  error: (state) => {
    return state.error;
  },
};
